import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

/**
 * User Store
 * Manages user state across the application
 */
export const useUserStore = create(
  devtools(
    persist(
      (set) => ({
        // State
        user: null,

        // Actions
        setUser: (user) => set({ user }),
        clearUser: () => set({ user: null }),
      }),
      {
        name: 'user-storage', // name of the item in local storage
        partialize: (state) => ({ user: state.user }),
      },
      {
        name: 'UserStore',
      }
    )
  )
)
